import PropTypes from 'prop-types';
import styled from 'styled-components';
import LazyLoadedImage from '../../LazyLoadedImage/LazyLoadedImage';

const DivProductListImage = styled.div` 
  margin: 0 auto 20px;
  text-align: center;
  flex-basis: 100%;
  img.product-image, .product-image img {
    width: 100%;
    height: auto;
    background: #ffffff;
    color: #213038;
    display: inline-block;
  }

  @media ${({ theme }) => theme.breakpoints.mobileMin} {
    max-width: 240px;
    flex: 1 auto;
    margin-right: 30px;
    margin-bottom: 0;
  }

  @media ${({ theme }) => theme.breakpoints.tablet} {
    max-width: 140px;
    margin-right: 20px;
  }

  @media screen and (min-width: 600px) and (max-width: 725px) {
    max-width: 100px;
  }

  @media ${({ theme }) => theme.breakpoints.touch} {
    margin-left: 0;
    .product-images {
      position: relative;
    }
    .image {
      max-width: 100%;
      height: auto;
    }
  }

  @media ${({ theme }) => theme.breakpoints.desktop} {
    margin-bottom: 0;
  }

  .clickableArea {
    width: 100%;
    @media ${({ theme }) => theme.breakpoints.mobileMin} {
      width: 240px;
    }

    @media ${({ theme }) => theme.breakpoints.mobile} {
      left: 0;
    }
  }

  .product .badges {
    display: inline-block;
  }

  .hasBadges .image {
    margin-bottom: 0;
  }
`;


const DivProductImages = styled.div` 
  display: inline-block;

  @media ${({ theme }) => theme.breakpoints.mobileMin} {
    margin-bottom: 10px;
  }

  img {
    @media ${({ theme }) => theme.breakpoints.mobileMin} {
      max-width: 100%;
      width: 100%;
    }
  }
`;

const ListItemImageAndBadges = ({ link, icons, onClick, loadImagesLazily, image }) => (
  <DivProductListImage className={'productListImage'} onClick={onClick}>
    <a href={link} className={`imgC ${icons ? 'hasBadges' : ''}`}>
      <DivProductImages className={'product-images'}>
        {loadImagesLazily
          ? (
            <LazyLoadedImage
              src={image.src}
              className={'image product-image'}
              alt={image.label}
              width={'250'}
              height={'213'}
            />
          )
          : (
            <img
              src={image.src}
              className={'image product-image'}
              alt={image.label}
              width={'250'}
              height={'213'}
            />
          )}
      </DivProductImages>
    </a>
    {icons && (
      <div className={'badges'}>
        {icons.map((badge, i) => (
          <a
            href={badge.linkUrl ? badge.linkUrl : ''}
            // eslint-disable-next-line react/jsx-no-target-blank
            target={'_blank'}
            rel={'noopener noreferrer'}
            // eslint-disable-next-line react/no-array-index-key
            key={i}
          >
            {loadImagesLazily
              ? <LazyLoadedImage src={badge.imgUrl} alt={''} />
              : <img src={badge.imgUrl} alt={''} />}
          </a>
        ))}
      </div>
    )}
    {/* eslint-disable jsx-a11y/anchor-has-content */}
    <a className={'clickableArea'} href={link} />
  </DivProductListImage>
);

ListItemImageAndBadges.propTypes = {
  link: PropTypes.string.isRequired,
  icons: PropTypes.arrayOf(
    PropTypes.shape({
      imgUrl: PropTypes.string.isRequired,
      linkUrl: PropTypes.string
    })
  ),
  onClick: PropTypes.func,
  loadImagesLazily: PropTypes.bool,
  image: PropTypes.shape({
    src: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired
  }).isRequired
};

ListItemImageAndBadges.defaultProps = {
  icons: undefined,
  onClick: () => {},
  loadImagesLazily: false
};

export default ListItemImageAndBadges;
